import { useEffect, useState } from "react";
import { ALLOWED_CODE_ACTES } from "../actesDefinitions";

const now = new Date();

const getMilestoneStatus = (acteLegislatif, decision) => {
	if (decision?.libelleStatutConclusion) {
		return "complete";
	}

	if (acteLegislatif.dateActe && new Date(acteLegislatif?.dateActe) < now) {
		return "complete";
	}

	return "active";
};

const getStepStatus = (acteLegislatif, currentActe, isLast) => {
	const codesCurrentActe =
		ALLOWED_CODE_ACTES[acteLegislatif.codeActe]?.codesCurrentActe;

	if(!isLast) {
		return "complete";
	}

	if (
		acteLegislatif?.uid === currentActe.uid ||
		codesCurrentActe?.includes(currentActe.codeActe)
	) {
		return "active";
	}

	if (acteLegislatif?.dateActe && new Date(acteLegislatif?.dateActe) < now) {
		return "complete";
	}

	if (!acteLegislatif || new Date(acteLegislatif?.dateActe) > now) {
		return "pending";
	}
	return "complete";
};

export const useMilestones = (actesLegislatifs, uidDernierActe) => {
	const [milestones, setMilestones] = useState([]);
	const [steps, setSteps] = useState([]);
	const [currentActe, setCurrentActe] = useState(null);

	useEffect(() => {
		const filteredActesLegislatifs = actesLegislatifs
			.filter((a) => Object.keys(ALLOWED_CODE_ACTES).includes(a.codeActe))
			.filter(
				(c, index, self) =>
					index ===
					self.findIndex(
						(t) =>
							t.codeActe === c.codeActe &&
							t.uid.substring(0, 3) === c.uid.substring(0, 3),
					),
			)
			.sort(
				(a, b) =>
					ALLOWED_CODE_ACTES[a.codeActe]?.order -
					ALLOWED_CODE_ACTES[b.codeActe]?.order,
			);

		if (!(filteredActesLegislatifs.length > 0)) return;

		const lastActe = actesLegislatifs.find((a) =>
			a.uid.startsWith(uidDernierActe),
		);
		const currentActe = filteredActesLegislatifs.find(
			(a) =>
				a.parentUid === lastActe.parentUid &&
				ALLOWED_CODE_ACTES[a.codeActe].codesCurrentActe?.includes(
					lastActe.codeActe,
				),
		) || filteredActesLegislatifs[0];

		const newMilestones = [];

		const mainActes = filteredActesLegislatifs
			?.filter((f) => !ALLOWED_CODE_ACTES[f.codeActe]?.parent)
			.reduce((accumulator, current) => {
				if (
					!current.codeActe.includes("DEPOT") ||
					!accumulator.find((item) => item.codeActe.includes("DEPOT"))
				) {
					accumulator.push(current);
				}
				return accumulator;
			}, []);

		mainActes?.map((a) => {
			const acteDefinition = ALLOWED_CODE_ACTES[a.codeActe];
			const acteDecision = actesLegislatifs.find(
				(c) => c.codeActe === acteDefinition.codeActeDecision,
			);
			const milestoneStatus = getMilestoneStatus(a, acteDecision);

			const newMilestone = {
				title: acteDefinition.title,
				acteLegislatif: a,
				chambre: a.chambre || acteDefinition.chambre,
				status: milestoneStatus,
				decision: acteDecision?.libelleStatutConclusion,
				dateDecision: acteDecision?.dateActe,
				steps: filteredActesLegislatifs
					.filter(
						(c, index, self) =>
							index ===
								self.findIndex(
									(t) =>
										t.codeActe === c.codeActe &&
										t.uid.substring(0, 3) === c.uid.substring(0, 3),
								) && ALLOWED_CODE_ACTES[c.codeActe].parent === a.codeActe
								&& c.parentUid === a.uid,
					)
					.map((step, index, array) => ({
						title: ALLOWED_CODE_ACTES[step.codeActe].title,
						acteLegislatif: step,
						status: getStepStatus(step, currentActe, index === array.length - 1),
					})),
			};
			if (
				newMilestone.steps?.length > 0 ||
				(newMilestone.steps?.length === 0 &&
					acteDefinition.hideIfNoSteps !== true)
			) {
				newMilestones.push(newMilestone);
			}
		});

		const timelineSteps = newMilestones
			.reduce((accumulator, milestone) => {
				return milestone.steps?.length > 0
					? accumulator.concat(
							milestone.steps.map((step) => step.acteLegislatif?.uid),
						)
					: accumulator.concat(
							milestone.acteLegislatif?.dateActe &&
								milestone.acteLegislatif?.uid,
						);
			}, [])
			.filter((e) => e);

		setCurrentActe(currentActe);
		setMilestones(newMilestones);
		setSteps(timelineSteps);
	}, [actesLegislatifs]);

	return { milestones, steps, currentActe };
};
